import moment from 'moment';
import {SICKNESS, PATERNITY_CODE, PATERNITY_SECOND_PERIOD_CODE} from 'common/domain/constants';
import {Request} from 'common/domain/models/request';
import {EVENTS} from 'common/domain/constants';
import CalendarContextMenuRenderer from './calendarContextMenu.renderer';
import PeriodActionsHelper from 'vacations-absences.module/common/helpers/periodActions.helpers';

class CalendarContextMenuController {

  constructor($scope, $rootScope, $timeout, $window) {
    'ngInject';
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.timeout = $timeout;
    this.window = $window;
    this.renderer = new CalendarContextMenuRenderer();
    this.hideContextMenuOnOutsideClick();
    this.showContextMenuOnRequestDayClick();
  }

  periodAvailable() {
    return this.period !== undefined && this.period !== null;
  }

  openAbsences() {
    this.onOpenAbsences({$event: this.getEmittedData()});
  }

  editPeriod() {
    this.onEditPeriod({$event: this.getEmittedData()});
  }

  removePeriod() {
    this.rootScope.$broadcast(EVENTS.CONTEXT_MENU_REMOVE, this.getEmittedData());
  }

  showContextMenuOnRequestDayClick() {
    this.scope.$on(EVENTS.REQUEST_DAY_CLICK, (event, args) => {
      if (this.isDisabled) {
        return;
      }

      this.showContextMenu(args.$event);
    });
  }

  cancelShow() {
    if (!this.period) {
      return false;
    }

    return !this.canInsertAbsence() && !this.periodCanBeEdited() && !this.periodCanBeRemoved();
  }

  canInsertAbsence() {
    return Request.isVacation(this.period) && Request.isApproved(this.period);
  }

  periodCanBeEdited() {
    if (SICKNESS.CODES.indexOf(this.period.code) === -1 && moment().isAfter(this.period.endDate)) {
      return false;
    }

    if(this.period.code === PATERNITY_CODE || this.period.code === PATERNITY_SECOND_PERIOD_CODE) {
      return false;
    }

    if (this.vacationOnInception(this.dayClicked, this.isInception)) {
      return false;
    }

    if(this.period.onlyVisualization === true){
      return false;
    }
    if(this.isInception){
      return Request.isRequested(this.period) && (this.period.code === SICKNESS.CODES[1] || this.period.code === SICKNESS.CODES[2]);
    }

    return Request.isRequested(this.period) && !this.isInception;
  }

  periodCanBeRemoved() {
    const approvedOrRequested = Request.isRequested(this.period) || Request.isApproved(this.period);
    const isSick = Request.isSick(this.period);

    if(this.period.onlyVisualization === true){
      return false;
    }
    return (approvedOrRequested && !isSick) && !this.isInception;
  }

  isFinishedSickPeriod() {
    return Request.isFinishedSick(this.period) && Request.isApproved(this.period);
  }

  getEmittedData() {
    return {
      dayClicked: this.dayClicked,
      dateDayClicked: this.dateDayClicked,
      period: this.period
    };
  }

  setHandlerResize() {
    this.renderer.onresize(this.dayClicked, () => {
      this.showContextMenu({
        dayClicked: this.dayClicked,
        dateDayClicked: this.dateDayClicked
      });
    });
  }

  showContextMenu({dayClicked, dateDayClicked, period}) {
    this.period = period;
    this.periodActionsHelper = new PeriodActionsHelper(this.period, this.isInception);
    this.dayClicked = dayClicked;
    this.dateDayClicked = dateDayClicked;
    this.setHandlerResize();

    if (!this.periodActionsHelper.available()) {
      return this.hideContextMenu();
    }

    this.timeout(() => this.renderer.show(dayClicked));
  }

  hideContextMenuOnOutsideClick() {
    this.renderer.hideContextMenuOnOutsideClick(() => this.hideContextMenu());
  }

  hideContextMenu() {
    this.dayClicked = null;
    this.renderer.hide();
  }
}

export default CalendarContextMenuController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarContextMenu/calendarContextMenu.controller.js